import React from "react";

const sizes = {
  texts: "text-[16px] font-normal lg:text-[13px]",
  textmd: "text-[20px] font-normal lg:text-[17px]",
  textlg: "text-[22px] font-normal lg:text-[18px]",
  textxl: "text-[24px] font-light lg:text-[20px] md:text-[22px]",
  text2xl:
    "text-[32px] font-normal lg:text-[27px] md:text-[30px] sm:text-[28px]",
  text3xl:
    "text-[34px] font-normal lg:text-[28px] md:text-[32px] sm:text-[30px]",
  text5xl:
    "text-[48px] font-normal lg:text-[40px] md:text-[44px] sm:text-[38px]",
  text7xl: "text-[72px] font-normal lg:text-[72px] md: text-[48px]",
};
const Text = ({
  children,
  className = "",
  as,
  size = "text2xl",
  ...restProps
}) => {
  const Component = as || "p";

  return (
    <Component
      className={`text-gray-100 font-spacegrotesk ${className} ${sizes[size]}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Text };
